// A react component that renders the GuideMessaging in a View pinned to the header of the page

import { type Href, router, useGlobalSearchParams } from 'expo-router';
import { useAtom } from 'jotai';
import * as React from 'react';
import { useEffect } from 'react';
import { isNonMobileWeb, PanelModal } from 'smoothie';

import { showGuideMessagingModalAtom } from '../state/MessagingAtoms';
import GuideMessaging from './GuideMessaging';

export const NonMobileGuideMessagingHref: Href = {
    pathname: '/home/my-guide',
    params: { showMessaging: 'true' },
};

export const backToGuideMessagingFromFileViewer = () => {
    backToGuideMessagingFromChatFeature();
};
export const backToGuideMessagingFromSearch = () => {
    backToGuideMessagingFromChatFeature();
};

const backToGuideMessagingFromChatFeature = () => {
    if (router.canGoBack()) {
        router.back();
    } else {
        if (isNonMobileWeb) {
            router.replace(NonMobileGuideMessagingHref);
        } else {
            router.navigate('/messaging/guide-messaging');
        }
    }
};

export const GuideMessagingModal = () => {
    const [showGuideMessagingModal, setShowGuideMessagingModal] = useAtom(
        showGuideMessagingModalAtom,
    );

    const { showMessaging: showMessagingParam } = useGlobalSearchParams<{
        showMessaging?: string;
    }>();

    useEffect(() => {
        if (showMessagingParam === 'true') {
            setShowGuideMessagingModal(true);
            router.setParams({});
        }
    }, [showMessagingParam]);

    return (
        <PanelModal
            isOpen={showGuideMessagingModal}
            onClose={() => {
                setShowGuideMessagingModal(false);
            }}
            contentProps={{
                height: '80vh',
                maxHeight: 700,
                width: '80vw',
                maxWidth: 550,
                top: 82,
                right: 66,
            }}
        >
            <GuideMessaging />
        </PanelModal>
    );
};
